<script>
export default {
  name: "CallToAction"
}
</script>

<template>
  <section class="call-to-action">
    <article class="has-text-centered">
      <header>
        <h2 class="article-title mb-2 has-text-white"></h2>
      </header>
      <router-link
          class="button is-large"
          :to="{name: 'BrochureFreeTrial'}"
      >
        Start a Free Trial!
      </router-link>
    </article>
    <aside class="mt-4 has-text-centered has-text-white">
      <h2 class="article-section-sub-title mb-4 has-text-white">or</h2>
      <router-link
          class="button is-white is-outlined"
          :to="{name: 'FeaturesView'}"
      >
        Explore the Platform
      </router-link>
    </aside>

  </section>
</template>

<style scoped lang="scss">
  .call-to-action {}
</style>